import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Paper } from '@mui/material';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '../../../../../components/common/Accordion';
import { Grid, Button, DataLoading } from '../../../../../components/common';
import AccordionFormContext from '../../../../../store/accordion-form-context';
import { loan } from '../../../../../utils';
import {
  objectToCsv,
  downloadCsvFile,
  processLoanData,
} from '../accordionFormFunctions';

export default function Summary() {
  const history = useHistory;
  const accordionCTX = useContext(AccordionFormContext);

  const submitCSVRequest = async () => {
    await loan
      .application(accordionCTX.form.loanApplicationID)
      .then((result) => {
        if (result.status === 403) {
          history.push('/login');
        }
        if (result.data != null) {
          const csvData = objectToCsv([processLoanData(result.data)]);
          downloadCsvFile(csvData);
        }
      })
      .catch(() => {});
  };

  return (
    <Accordion
      square
      expanded={accordionCTX.navigation.expanded === 'panel9'}
      onChange={() => accordionCTX.changeNavigation('CHANGE', 'panel9')}
    >
      <AccordionSummary aria-controls="panel9d-content" id="panel9d-header">
        <h1>9. Podsumowanie</h1>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid
            infoCard
            topMargin
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            component={Paper}
          >
            <Typography variant="h4">
              {accordionCTX.navigation.finalText}
            </Typography>
          </Grid>
          {accordionCTX.form.loanApplicationID >= 0 && (
            <Grid
              topMargin
              container
              justifyContent="center"
              alignItems="center"
              sx={{ textAlign: 'center' }}
            >
              <Button
                onClick={async () => await submitCSVRequest()}
                variant="contained"
              >
                {accordionCTX.navigation.loanDataLoading ? (
                  <DataLoading />
                ) : (
                  'Przejdź dalej w celu podpisania umowy.'
                )}
              </Button>
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
